var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#8754ba}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4415",
    "data-name": "Group 4415",
    transform: "translate(-928 -2177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clipboard",
    transform: "translate(888.963 2183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4414",
    "data-name": "Group 4414",
    transform: "translate(47.037)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4413",
    "data-name": "Group 4413"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2065",
    "data-name": "Path 2065",
    className: "cls-2",
    d: "M59.977 2.473H58.27v-.764c0-.247-.27-.359-.517-.359h-1.325a2.01 2.01 0 0 0-2-1.348 2.044 2.044 0 0 0-2 1.348h-1.3c-.247 0-.494.112-.494.359v.764h-1.71a1.91 1.91 0 0 0-1.887 1.82v12.873a1.808 1.808 0 0 0 1.887 1.707h11.053a1.808 1.808 0 0 0 1.887-1.707V4.293a1.91 1.91 0 0 0-1.887-1.82zm-8.447-.225h1.236a.494.494 0 0 0 .427-.4A1.3 1.3 0 0 1 54.428.833a1.28 1.28 0 0 1 1.213 1.011.494.494 0 0 0 .449.4h1.281v1.8H51.53zm9.436 14.917a.911.911 0 0 1-.989.809H48.924a.911.911 0 0 1-.989-.809V4.293a1.011 1.011 0 0 1 .989-.921h1.707v1.145a.472.472 0 0 0 .494.427h6.627a.494.494 0 0 0 .517-.427V3.372h1.707a1.011 1.011 0 0 1 .989.921v12.873z",
    transform: "translate(-47.037)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2066",
    "data-name": "Path 2066",
    className: "cls-2",
    d: "M102.814 230.452a.449.449 0 0 0-.629-.022l-1.438 1.37-.607-.629a.449.449 0 0 0-.629-.022.472.472 0 0 0 0 .652l.921.944a.4.4 0 0 0 .315.135.449.449 0 0 0 .315-.135l1.752-1.662a.427.427 0 0 0 .026-.6z",
    transform: "translate(-97.13 -220.408)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2067",
    "data-name": "Path 2067",
    className: "cls-2",
    d: "M204.164 256.034H199a.449.449 0 1 0 0 .9h5.167a.449.449 0 0 0 0-.9z",
    transform: "translate(-192.033 -245.024)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2068",
    "data-name": "Path 2068",
    className: "cls-2",
    d: "M102.814 146.859a.449.449 0 0 0-.629-.022l-1.438 1.37-.607-.629a.449.449 0 0 0-.629-.022.472.472 0 0 0 0 .652l.921.944a.4.4 0 0 0 .315.135.449.449 0 0 0 .315-.135l1.752-1.662a.427.427 0 0 0 .026-.6z",
    transform: "translate(-97.13 -140.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2069",
    "data-name": "Path 2069",
    className: "cls-2",
    d: "M204.164 172.442H199a.449.449 0 1 0 0 .9h5.167a.449.449 0 0 0 0-.9z",
    transform: "translate(-192.033 -165.027)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2070",
    "data-name": "Path 2070",
    className: "cls-2",
    d: "M102.814 314.043a.449.449 0 0 0-.629-.022l-1.438 1.37-.607-.629a.449.449 0 0 0-.629-.022.472.472 0 0 0 0 .652l.921.944a.4.4 0 0 0 .315.135.449.449 0 0 0 .315-.135l1.752-1.662a.427.427 0 0 0 .026-.6z",
    transform: "translate(-97.13 -300.405)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2071",
    "data-name": "Path 2071",
    className: "cls-2",
    d: "M204.164 339.626H199a.449.449 0 1 0 0 .9h5.167a.449.449 0 0 0 0-.9z",
    transform: "translate(-192.033 -325.022)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.18f48871.svg";
export { ForwardRef as ReactComponent };